// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-comments-settings {
  display: inline-block;
}
fi-comments-settings .mat-mdc-radio-button {
  display: block;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-comments/fi-comments-settings/fi-comments-settings.component.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;AACI;EACI,cAAA;AACR","sourcesContent":["fi-comments-settings {\r\n    display: inline-block;\r\n\r\n    .mat-mdc-radio-button {\r\n        display: block;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
